import { Configuration, PopupRequest } from "@azure/msal-browser";
import config from "./config";

export const msalConfig: Configuration = {
    auth: config.azure.msal,
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    },
};

export const loginRequest: PopupRequest = {
    scopes: [
        "User.Read",
        "Files.Read",
        // Add your Azure Functions API scope
        `${config.azureFunctionCLientId}/user_impersonation`
    ]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};